import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Logo from '../../../../../assets/Logo.svg';
import SoundOff from '../../../../../assets/navbar/music-off.svg';
import SoundOn from '../../../../../assets/navbar/music-on.svg';
import { soundIconClicked } from '../../../../../core/usecases/music/SoundIconClicked';
import {
  selectIsMusicEnabled,
  selectIsVolumeSliderVisible,
  selectScreenOrientation,
  selectSoundtrack,
  selectSoundtrackVolume,
} from '../../../../../store/selectors/global.selector';
import MusicPlayer from '../background-music-player';
import ClientSandwichMenu from './ClientSandwichMenu';
import VolumeSlider from '../VolumeSlider';
import { setSoundtrackVolumeFromVolumeSlider } from '../../../../../core/usecases/music/SetSoundtrackVolumeFromVolumeSlider';
import { DEFAULT_SOUNDTRACK_VOLUME_LEVEL } from '../../../../../constants/app-constants';

const ClientMobileNavbar = () => {
  const dispatch = useDispatch();
  const soundtrackVolume: number = useSelector(selectSoundtrackVolume);
  const audioRef = useRef<HTMLAudioElement>(null);
  const showVolumeSlider = useSelector(selectIsVolumeSliderVisible);

  const orientation = useSelector(selectScreenOrientation);
  const landscape = orientation === 'LANDSCAPE';

  const musicOn = useSelector(selectIsMusicEnabled);

  const soundtrack = useSelector(selectSoundtrack);
  const musicSelected = soundtrack !== undefined;

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = soundtrackVolume;
    }
  }, [soundtrackVolume]);

  const handleSoundIconClicked = () => {
    dispatch<any>(soundIconClicked());
  };

  const handleVolumeChange = (e: number[] | undefined) => {
    const volume = e?.at(0);
    dispatch<any>(setSoundtrackVolumeFromVolumeSlider(volume));
  };

  return (
    <>
      {!landscape && (
        <div className="w-screen h-60 fixed top-0 bg-white pl-3 pr-4 flex justify-between items-center z-50 ">
          <img src={Logo} alt="" className="h-15" />
          <ClientSandwichMenu />
          {musicSelected && showVolumeSlider && (
            <div className="flex justify-end w-[240px] gap-1">
              <div className="flex">{<img src={musicOn ? SoundOn : SoundOff} alt="" className="cursor-pointer w-5" onClick={handleSoundIconClicked} />}</div>
              <VolumeSlider
                value={musicOn ? [soundtrackVolume] : [0]}
                onValueChange={handleVolumeChange}
                defaultValue={musicOn ? [DEFAULT_SOUNDTRACK_VOLUME_LEVEL] : [0]}
              />
            </div>
          )}
        </div>
      )}

      <MusicPlayer />
    </>
  );
};
export default ClientMobileNavbar;
